module.exports = __webpack_public_path__ + "media/images/cellar-head-bc9fc5b7ecd0cb2e397f1c1619642b53.jpg";